
export default {
    papel: {},
    papeis: []
}